<template>
    <b-row v-if="apiData && apiData.length > 0" class="mt-3"
        ><b-col cols="3">
            <b-card :title="$t('dashboard.dashboardAlerts.alertBoxTitle')">
                <b-card-text>
                    <router-link
                        to="/dashboard/dashboardalerts"
                        :title="$t('dashboard.dashboardAlerts.linkText')"
                        >{{
                            $t('dashboard.dashboardAlerts.layerErrors')
                        }}</router-link
                    >
                </b-card-text>
            </b-card>
        </b-col></b-row
    >
</template>
<script>
    export default {
        data() {
            return {
                apiData: null, // This will store the data from the API
                pollInterval: null // To keep track of the polling interval
            };
        },
        methods: {
            // Method to call the API
            async fetchData() {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetThemeLayerErrors'
                });
                this.apiData = result.data;
            },
            // Method to start polling
            startPolling() {
                // Fetch the data initially
                this.fetchData();

                // Set up polling at a regular interval
                this.pollInterval = setInterval(() => {
                    this.fetchData();
                }, 60000); // Poll every minute
            },
            // Method to stop polling
            stopPolling() {
                if (this.pollInterval) {
                    clearInterval(this.pollInterval);
                }
            }
        },
        mounted() {
            // Start polling when the component is mounted
            this.startPolling();
        },
        beforeDestroy() {
            // Stop polling when the component is destroyed
            this.stopPolling();
        }
    };
</script>
